import { COMMISSIONS_POLICIES_CLEAR_STATE } from '../constants'
import  initialState  from '../initialState'

export function reducer(state, action) {
  if (action.type === COMMISSIONS_POLICIES_CLEAR_STATE) {
      return initialState
  }
  else {
      return state
  }
}
